<template>
  <div class="db-3 screen">
    <div class="body-wrapper">
      <billing-component />
    </div>
  </div>
</template>

<script>
import BillingComponent from './BillingComponent.vue';

export default {
  components: { BillingComponent },
};
</script>

<style scoped>
.db-3 {
  align-items: center;
  background-color: var(--white);
  display: flex;
  flex-direction: column;

  margin-top: 3.75rem;
}
.body-wrapper {
  margin-top: 2rem;
}
</style>
